import moment from 'moment'
import { get } from 'lodash'
import flightGraph from 'core-lib/components/flightGraph/flightGraph.vue'
import flightDetailsTimeline from 'core-lib/components/flightDetailsTimeline/flightDetailsTimeline.vue'
import fareConditions from './FareConditionsMobile'

export default {
  name: 'flightComponent',
  title: 'pagination',
  inject: ['isMobile'],
  props: [
    'airports',
    'journey',
    'flightsSource',
    'removeSeconds',
    'familyFares',
    'journeyName',
    'journeys',
    'showTimeLine',
    'filters',
    'notListedFares',
    'value',
    'index',
    'showSummary',
    'fareSelected',
    'soldOutFareConfig',
    'familyFareRules',
    'showFamilyFareRules'
  ],
  components: {
    flightGraph,
    flightDetailsTimeline,
    fareConditions
  },
  data () {
    return {
      isOpen: false,
      isTooltipOpen: false,
      //modal mobile
      showFamilyFareModal: false,
      fareMap: {},
      finalList: [],
      generalInfo: {
        flyTime: this.journey.order.total_time ? this.journey.order.total_time : this.journey.time_on_fly,
        stops: this.journey.flights.length > 1 ? this.journey.flights.length : this.flightsSource[this.journey.flights[0]].flight_stops
      },
      flight: this.flightsSource[this.journey.flights[0]],
      stopsQuantity: 0,
      showDetails: false,
      lockDetails: false
    }
  },
  computed: {
    flightRemarks () {
      let remarks = []
      if (this.flight.flight_additional_information.flight_remarks_list) {
        remarks = this.flight.flight_additional_information.flight_remarks_list
      }
      return remarks
    },
    showFlightRemarks () {
      return get(this.ecommerceSetup, 'show_flight_remarks')
    },
    flightResultsAmountPerPax () {
      let res = false
      if (get(this.ecommerceSetup, 'flight_results_amount')) {
        res = this.ecommerceSetup.flight_results_amount.includes(
          'TOTAL AMOUNTS PER ADT'
        )
      }
      return res
    },
    departureTime () {
      return this.flightsSource[this.journey.flights[0]].departure_information.time
    },
    arrivalTime () {
      return this.flightsSource[this.journey.flights[this.journey.flights.length -1]].arrival_information.time
    },
    ecommerceSetup: function () {
      return get(this.$store.getters.getGeneralSettings, 'ecommerce_setup')
    }
  },
  mounted () {
    this.timeLineData()
    this.allStopsQuantity()
    if (this.slideTo) {
      this.swiper.slideTo(0, 1000, false)
    }
  },
  methods: {
    cleanFareName (fareName) {
      return fareName.split('_')[0]
    },
    getAverageAmount (journey) {
      return journey[
        this.flightResultsAmountPerPax ? 'average_amount_per_pax_adt': 'average_amount'
      ]
    },
    toggleDetails: async function () {
      if (this.lockDetails) {
        event.stopPropagation()
        return
      }
      this.lockDetails = true
      if (this.showDetails) await new Promise(r => setTimeout(r, 400)) // wait close collapse
      this.showDetails = !this.showDetails
      if (this.showDetails) await new Promise(r => setTimeout(r, 400)) // wait open collapse
      this.lockDetails = false
    },
    currency () {
      return this.journey.fares[Object.keys(this.journey.fares).find(x => this.journey.fares[x].currency_reference_id != null)].currency_reference_id.split('_')[0]
    },
    cleanFlightsArray (array) {
      let index = -1
      let arrLength = array ? array.length : 0
      let resIndex = -1
      let result = []
      while (++index < arrLength) {
        let value = array[index]
        if (value) result[++resIndex] = value
      }
      return result.filter(Boolean)
    },
    getSplittedName (name, character, segment) {
      if (!character) { character = '_' }
      if (!segment) { segment = 0 }
      return name.split(character)[segment]
    },
    filteredFlights (arr, departure) {
      let filter = []
      arr.rbds.map(function (rbd, i) {
        let key = arr.rbds.map(function (e) { return e.rbd }).indexOf(rbd.rbd)
        key = i === key ? i : key
        if (rbd.rbd === rbd.reference || (rbd.total_amount <= arr.rbds[key].total_amount && rbd.rbd !== arr.rbds[key].rbd)) filter[i] = arr.rbds[i]
      })
      return this.cleanFlightsArray(filter)
    },
    rbdTitle (rbd) {
      return this.$i18nParse(rbd.title, this.$i18n.locale, rbd.reference)
    },
    defineAvailableSeats (available) {
      available = parseInt(available)
      if (available === 0) return this.$t('sold_out_message')
      if (available >= 2 && available <= 8) return [available, this.$t('lasts')].join(' ')
      if (available === 9) return this.$t('available')
      else return [available, this.$t('last_seat')].join(' ')
    },
    getAmountToDisplay (rbd) {
      let hasReturn = this.journeys[0].return_flights
      let flightGoingPriceDivided = this.journeys.flightSelectedGoingPriceDivided
      if (flightGoingPriceDivided) { // SE ESTA SELECCIONANDO LA VUELTA
        return (parseFloat(rbd.total_amount) - parseFloat(flightGoingPriceDivided)).toFixed(2)
      } else if (hasReturn[0].airline) { // SE SELECCIONO LA IDA
        return (parseFloat(rbd.total_amount) / 2).toFixed(2)
      } else { // ES SOLO IDA
        return parseFloat(rbd.total_amount).toFixed(2)
      }
    },
    onSelected (price, flight) {
      if (price && flight) {
        if (this.notAvailable(price, flight) || this.isSoldOut(price, flight)) {
          return
        }
        const fare = {
          price: this.journey.fares[price],
          name: price
        }
        const finalList = this.finalList
        const journeyName = this.journeyName
        const generalInfo = this.generalInfo
        this.$emit('onSelected', { price, flight, fare, journeyName, finalList, generalInfo })
      }
    },
    isSoldOut (fare, journey) {
      return journey.fares[fare].rbd.posting === 0 && this.soldOutFareConfig.show_amount_in_table
    },
    notAvailable (fare, journey) {
      return journey.fares[fare].rbd.posting === 0 && !this.soldOutFareConfig.show_amount_in_table
    },
    beautifyCarrier (carrier) {
      return carrier.split('00')[1].split('_')[0]
    },
    getFareSelectedTitle () {
      return this.fareSelected ? this.fareSelected.title : null
    },
    buildCardInfo (flight, orientation) {
      // if (flight[`${orientation}_information`].airport_reference_id && this.airports[this.flight[`${orientation}_information`].airport_reference_id.split('_')[0]]) {
      //   city = this.airports[flight[`${orientation}_information`].airport_reference_id.split('_')[0]].city.description
      // } else {
      //   city = this.flight[`${orientation}_information`].location_reference_id.split('_')[0]
      // }
      return {
        airport: flight[`${orientation}_information`].airport_reference_id ? this.$t(this.$getAirportName(flight[`${orientation}_information`].airport_reference_id)) : this.$t(this.$getAirportName(flight[`${orientation}_information`].location_reference_id.split('_')[0])),
        airportShort: flight[`${orientation}_information`].airport_reference_id ? flight[`${orientation}_information`].airport_reference_id.split('_')[0] : flight[`${orientation}_information`].location_reference_id.split('_')[0],
        city: flight[`${orientation}_information`].airport_reference_id ? this.$t(this.$getCityName(flight[`${orientation}_information`].airport_reference_id.split('_')[0])) : this.$t(this.$getCityName(flight[`${orientation}_information`].location_reference_id.split('_')[0])),
        datetime: flight[`${orientation}_information`].date,
        time: flight[`${orientation}_information`].time,
        changeDayIndicator: orientation !== 'departure' ? flight[`${orientation}_information`].change_day_indicator : null
      }
    },
    getCard (flight) {
      let departure = this.buildCardInfo(flight, 'departure')
      let arrival = this.buildCardInfo(flight, 'arrival')

      let card = {
        // TODO airline - carrier code - flight number
        airline: this.beautifyCarrier(flight.carrier_reference_id),
        journeyDuration: flight.flight_time ? flight.flight_time : flight.flight_elapsed_time,
        carrierCode: this.beautifyCarrier(flight.carrier_reference_id),
        plane: flight.flight_additional_information ? flight.flight_additional_information.equipment.equipment_reference_id.split('_')[0] : null,
        departure,
        arrival
      }

      return card
    },
    allStopsQuantity() {
      this.finalList.forEach(item => {
        if (item.waitType == 'conection') {
          this.conectionsQuantity = this.conectionsQuantity + 1
        } else if(item.waitType == 'stop') {
          this.stopsQuantity = this.stopsQuantity + 1
        }
      })
    },
    timeLineData () {
      let conectFlightNumber = null
      if (this.journey.flights.length === 1) {
        const stopDetails = this.flight.flight_additional_information.flight_stops_details

        if (stopDetails.length) {
          stopDetails.forEach((flight, index) => {
            flight.carrier_reference_id = this.flight.carrier_reference_id

            let card = this.getCard(flight)

            const waitCardCondition = Object.keys(this.finalList).length % 2 !== 0

            const stopIndex = index !== 0 ? index - 1 : index

            let waitCard = {
              waitType: 'stop',
              time: {
                hours: moment(stopDetails[stopIndex].ground_time, 'HH:mm:ss').hours(),
                min: moment(stopDetails[stopIndex].ground_time, 'HH:mm:ss').minutes()
              }
            }

            card.flightNumber = conectFlightNumber ? conectFlightNumber : this.flight.flight_number

            if (waitCardCondition) {
              this.finalList.push(waitCard)
            }
            this.finalList.push(card)
          })
        } else {
          let card = this.getCard(this.flight)
          card.flightNumber = this.flight.flight_number
          this.finalList.push(card)
        }
      } else {
        this.journey.flights.forEach((stop, index) => {
          const flightNumber = stop
          stop = this.flightsSource[stop]

          const stopDetails = stop.flight_additional_information.flight_stops_details

          if (stopDetails.length) {
            stopDetails.forEach((flight, index) => {
              flight.carrier_reference_id = this.flight.carrier_reference_id

              let card = this.getCard(flight)

              const waitCardCondition = Object.keys(this.finalList).length % 2 !== 0

              const stopIndex = index !== 0 ? index - 1 : index

              let waitCard = {
                waitType: 'stop',
                time: {
                  hours: moment(stopDetails[stopIndex].ground_time, 'HH:mm:ss').hours(),
                  min: moment(stopDetails[stopIndex].ground_time, 'HH:mm:ss').minutes()
                }
              }

              if (get(this.finalList[this.finalList.length-1], 'waitType') === 'conection') {
                conectFlightNumber = flightNumber.split(this.beautifyCarrier(this.flight.carrier_reference_id))[1]
                card.flightNumber = conectFlightNumber
              } else {
                card.flightNumber = conectFlightNumber ? conectFlightNumber : this.flight.flight_number
              }

              if (waitCardCondition) {
                this.finalList.push(waitCard)
              }
              this.finalList.push(card)
            })
          } else {

            let card = this.getCard(stop)
            card.flightNumber = flightNumber.split(this.beautifyCarrier(this.flight.carrier_reference_id))[1]

            this.finalList.push(card)
          }

          const waitCardCondition = Object.keys(this.finalList).length % 2 !== 0 && index !== this.journey.flights.length - 1

          let waitCard = {
            waitType: 'conection',
            time: stopDetails.time_on_stop ? stopDetails.time_on_stop : {}
          }

          if (this.journey.flights.length !== index + 1 && !stopDetails.time_on_stop) {
            const firstFlightDate = this.flightsSource[this.journey.flights[index]].arrival_information.date
            const firstFlightTime = this.flightsSource[this.journey.flights[index]].arrival_information.time
            const firstFlightDateTime = moment(firstFlightDate + ' ' + firstFlightTime, 'AAAA-MM-DD HH:mm:ss')

            const secondFlightDate = this.flightsSource[this.journey.flights[index + 1]].departure_information.date
            const secondFlightTime = this.flightsSource[this.journey.flights[index + 1]].departure_information.time
            const secondFlightDateTime = moment(secondFlightDate + ' ' + secondFlightTime, 'AAAA-MM-DD HH:mm:ss')

            const hoursBetween = moment.duration(secondFlightDateTime.diff(firstFlightDateTime)).hours()
            const minutesBetween = moment.duration(secondFlightDateTime.diff(firstFlightDateTime)).minutes()
            waitCard.time.hours = hoursBetween
            waitCard.time.min = minutesBetween
          }

          if (waitCardCondition) {
            this.finalList.push(waitCard)
          }
        })
      }
    },
    isLowestFare: function (fare) {
      const bestPrice = get(this.journey, 'lower_price_per_day', get(this.journey, 'order.lower_price'))
      return get(this.journey, `fares[${fare}].average_amount`) === bestPrice
    },
    isMoreThanOneFare () {
      return this.familyFares.filter(fam => this.journey.fares[fam].average_amount).length > 1
    },
    isUnavailableSeat (fare) {
      return Boolean(get(this.journey.fares[fare].rbd, 'posting', false))
    },
  }
}
